"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AddCategoryForm_1 = __importDefault(require("./AddCategoryForm"));
var DiseaseTable_1 = __importDefault(require("./DiseaseTable"));
var Form_1 = __importDefault(require("./Form"));
var Queries_1 = require("../Graphql/Queries");
var client_1 = require("@apollo/client");
var dis_hook_1 = require("../../../../context/DiseaseContext/dis.hook");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var DiseaseVideo = function (props) {
    var disease = (0, dis_hook_1.useDis)().disease;
    var organization = (0, org_hook_1.useOrg)().organization;
    var data = (0, client_1.useQuery)(Queries_1.GET_DISEASE_CATEGORY, {
        variables: { organization_id: organization.id, disease_id: disease.id },
        notifyOnNetworkStatusChange: true,
    }).data;
    var dataParentChild = (0, client_1.useQuery)(Queries_1.GET_DISEASE_CATEGORY_PARENT_CHILD, {
        variables: { organization_id: organization.id, disease_id: disease.id },
        notifyOnNetworkStatusChange: true,
    }).data;
    var setCatId = props.setCatId, diseaseinfoDetailResponse = props.diseaseinfoDetailResponse, 
    // diseaseCategoryList,
    languages = props.languages, getResponse = props.getResponse, editDiseaseParam = props.editDiseaseParam, clickStatus = props.clickStatus, saveDisease = props.saveDisease, setClickStatus = props.setClickStatus, ondiseasedelete = props.ondiseasedelete, ondiseaseedit = props.ondiseaseedit, getDiseaseCategory = props.getDiseaseCategory, upsertCategoryResponse = props.upsertCategoryResponse, onSavePressed = props.onSavePressed;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Form_1.default, { categoryId: function (e) { return setCatId(e); }, diseaseInfoDetailList: (diseaseinfoDetailResponse === null || diseaseinfoDetailResponse === void 0 ? void 0 : diseaseinfoDetailResponse.data)
                ? diseaseinfoDetailResponse.data.getDiseaseInfoDetail
                : [], languages: languages, 
            // diseaseCategoryList={diseaseCategoryList}
            list: data === null || data === void 0 ? void 0 : data.getDiseaseCategory, onEditClick: editDiseaseParam, saveClickStatus: clickStatus, saveDisease: function (data) {
                saveDisease(data);
            }, updateSaveClickStatus: function () { return setClickStatus(false); } }),
        react_1.default.createElement(DiseaseTable_1.default, { list: dataParentChild === null || dataParentChild === void 0 ? void 0 : dataParentChild.getDiseaseCategoryByParentChild, ondiseasedelete: function (payload) { return ondiseasedelete(payload); }, ondiseaseedit: function (payload) { return ondiseaseedit(payload); } }),
        react_1.default.createElement(AddCategoryForm_1.default, { getDiseaseCategory: getDiseaseCategory, getResponse: getResponse, isSuccess: upsertCategoryResponse === null || upsertCategoryResponse === void 0 ? void 0 : upsertCategoryResponse.data, languages: languages, list: data === null || data === void 0 ? void 0 : data.getDiseaseCategory, onSaveClick: function (data) { return onSavePressed(data); } })));
};
exports.default = DiseaseVideo;
